<div id="conteneur-contact-complet" class="conteneur-contact-complet-cnaf collapsable-cnaf space-above">
   <div class="row">
      <p class="spacing text-center">L'accueil téléphonique de votre Caf est actuellement <b>{{message}}</b>.</p>   
   </div>
   <div class="mise-en-avant-fond-cnaf">
      <div class="row">
         <p>
            <img src="/contactermacafappli/dist/assets/conseil.png" alt="conseil"><span
               id="conseil-titre" class="text-info"> Notre conseil</span>
         </p>
      </div>
      <div class="row">
         <p>Les appels téléphoniques sont moins nombreux l’après-midi, et aussi en fin de mois et fin de semaine. Si vous le pouvez, privilégiez ces créneaux pour appeler votre Caf.</p>
      </div>
   </div>
   <div clas="row">
      <p class="spacing text-center">
         En attendant, n'hesitez pas à poser vos questions à notre conseiller virtuel (bulle verte ci-dessous).
      </p>
   </div>
   <div clas="row" id="retour">
      <div class="text-center">
          <a class="btn btn-primary-cnaf espacement" (click)="clickOnRetour()">Retour</a>
      </div>
  </div>
</div>


